import Box from '@mui/material/Box'

import { SelectC } from 'components'
import {
  useLoadOrderCustomerByOpportunity,
  useLoadOrdersCustomers
} from 'modules/orders/hooks'
import { useOrderStore } from 'modules/orders/store'
import { useCallback, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useIsFetching } from 'react-query'
import { useLocation } from 'react-router-dom'
import { useStore } from 'store'
import { useDebounce } from 'utils'

export const SelectOrdersCustomers = () => {
  const pageLocation = useLocation()
  const isDuplicatePage = pageLocation.pathname.includes('/duplicate')

  const [searchCustomer, setSearchCustomer] = useState('')
  const { watch, setValue } = useFormContext()
  const searchCustomerDebounced = useDebounce(searchCustomer, 250)

  const opportunity = useStore((state: any) => state.opportunity)

  const form = useOrderStore.useForm()

  const paymentResponsible = form?.paymentResponsible

  const isFetchingOrderProductsPrice = useIsFetching(['orderProductsPrice']) > 0
  const isRecalculatingPrices = isDuplicatePage && isFetchingOrderProductsPrice

  const { data: ordersCustomers, isLoading: ordersCustomersLoading } =
    useLoadOrdersCustomers({
      page: 1,
      limit: 100,
      search: searchCustomerDebounced,
      sellerId: watch('seller')?.id
    })

  const { data: apiOpportunity, isLoading: apiOpportunityLoading } =
    useLoadOrderCustomerByOpportunity({
      opportunityId: opportunity?.id
    })

  const handleChangeCustomer = (value: string, reason: string) => {
    if (reason === 'input' || reason === 'clear') setSearchCustomer(value)
  }

  const handleSelectCustomer = useCallback(
    (v: any) => {
      if (!paymentResponsible?.id) setValue('paymentResponsible', v)
    },
    [paymentResponsible?.id, setValue]
  )

  return (
    <SelectC
      name="customer"
      options={ordersCustomers?.data || []}
      loading={ordersCustomersLoading || apiOpportunityLoading}
      onInputChange={(e, value, reason) => handleChangeCustomer(value, reason)}
      label="Cliente"
      getOptionLabel={(option: any) => option?.id + ' - ' + option?.name}
      disabled={
        isRecalculatingPrices ||
        !!apiOpportunity?.data?.customer?.id ||
        (!isDuplicatePage && !!watch('customer')?.id)
      }
      onChange={(e, v) => handleSelectCustomer(v)}
      renderOption={(props: any, option: any) => (
        <Box component="li" {...props}>
          <div>
            <div style={{ fontSize: 14, fontWeight: 500 }}>
              {option.id} - {option.name}
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                fontSize: 12
              }}
            >
              <div>{option.registration}</div>
              <div style={{ marginLeft: 4, marginRight: 4 }}>|</div>
              <div>{option?.address}</div>
            </div>
          </div>
        </Box>
      )}
    />
  )
}
